export const state = {
    loggedIn: localStorage.getItem('loggedIn')
}

export const mutations = {
    LOG_IN (state) {
        localStorage.setItem('loggedIn', true)
        state.loggedIn = true;
    },
    LOG_OUT(state) {
        //delete session cookie
        localStorage.removeItem('loggedIn')
        state.loggedIn = false;
    }
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return state.loggedIn;
    }
};